var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoCircle = function SvgLogoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16s7.163 16 16 16 16-7.163 16-16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0064",
    d: "M21.91 8.72c0-.48.18-.907.533-1.259.362-.362.81-.533 1.365-.533s1.013.17 1.387.512c.373.341.565.768.565 1.29 0 .513-.192.95-.565 1.291-.374.342-.843.512-1.387.512-.555 0-1.003-.181-1.365-.533-.352-.373-.534-.79-.534-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.032 6.928c1.141 0 2.176.683 2.635 1.728l7.093 16.405H6.24l7.168-16.426a2.87 2.87 0 0 1 2.624-1.707"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0086FF",
    d: "M14.837 17.83a2.9 2.9 0 0 0-.949-.16c-3.595 0-3.168 7.391-6.667 7.391h.534c5.333 0 5.898-4.458 7.082-7.232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    d: "M14.837 17.83c-1.184 2.773-1.749 7.242-7.082 7.242h16.693c-8.48-.01-6.688-6.197-9.61-7.243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0064",
    d: "M17.301 15.675c-1.28 0-1.93.906-2.464 2.154 2.923 1.046 1.131 7.232 9.611 7.232h1.227c-5.558 0-4.96-9.386-8.374-9.386"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgLogoCircle;